/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import 'typeface-roboto';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Snackbar from '@material-ui/core/Snackbar';

const useStyles = makeStyles({
  cardWrapper: {
    marginBottom: 5,
  },
});

const OrderRekeningPembayaran = (props) => {
  const classes = useStyles();
  const [toast, setToast] = React.useState(false);
  const { data } = props;

  const handleCopy = () => {
    setToast(true);
  };

  const handleToastClose = () => {
    setToast(false);
  };

  return (
    <Card className={classes.cardWrapper}>
      <CardHeader
        title="Rekening Pembayaran"
        subheader="Harap transfer sesuai Nilai Transfer"
      />
      <List>
        {
          data.map((bank, index) => (
            <ListItem key={index} button>
              <CopyToClipboard text={bank.bank_number} onCopy={handleCopy}>
                <Grid container justify="space-between">
                  <Grid item>
                    <Grid item container direction="column" justify="center" alignItems="flex-start">
                      <Grid item>
                        <Typography variant="button">{bank.bank_name}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">
                          {bank.bank_owner}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid item style={{ height: '100%' }} container direction="column" justify="center" alignItems="flex-end">
                      <Grid item>
                        <Typography variant="button">{bank.bank_number}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CopyToClipboard>
            </ListItem>
          ))
        }
      </List>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={toast}
        autoHideDuration={2000}
        onClose={handleToastClose}
        message="Nomor Rekening dicopy ke Clipboard"
        severity="success"
      />
    </Card>
  );
};

export default OrderRekeningPembayaran;
